class WebSocketManager {
  constructor(url) {
    this.ws = null
    this.url = url
    this.reconnectInterval = 5000
    this.heartbeatInterval = 15000
    this.reconnectTimer = null
    this.heartbeatTimer = null
    this.listeners = {}
    this.isManualClose = false
    this.reconnectAttempts = 0
    this.maxReconnectAttempts = 5
  }

  connect() {
    if (this.ws && (this.ws.readyState === WebSocket.CONNECTING || this.ws.readyState === WebSocket.OPEN)) {
      return
    }

    this.isManualClose = false

    try {
      this.ws = new WebSocket(this.url)

      this.ws.onopen = () => {
        console.log('WebSocket 连接成功')
        this.reconnectAttempts = 0
        this.startHeartbeat()
        this.emit('open', null)
      }

      this.ws.onmessage = (event) => {
        console.log('收到 WebSocket 消息:')
        try {
          const data = JSON.parse(event.data)
          this.emit('message', data)
        } catch (e) {
          this.emit('message', event.data)
        }
        this.startHeartbeat()
      }

      this.ws.onerror = (error) => {
        console.error('WebSocket 连接错误:', error)
        this.closeHeartbeat()
        this.emit('error', error)
      }

      this.ws.onclose = () => {
        console.log('WebSocket 连接关闭')
        this.closeHeartbeat()
        this.emit('close', null)
        if (!this.isManualClose) {
          this.handleReconnect()
        }
      }
    } catch (error) {
      console.error('创建 WebSocket 连接失败:', error)
      this.handleReconnect()
    }
  }

  handleReconnect() {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++
      console.log(`WebSocket 尝试重连... (${this.reconnectAttempts}/${this.maxReconnectAttempts})`)
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer)
      }
      this.reconnectTimer = setTimeout(() => {
        this.ws = null
        this.connect()
      }, this.reconnectInterval)
    } else {
      console.log('WebSocket 最大重连失败，终止重连')
    }
  }

  startHeartbeat() {
    if (this.isManualClose) return
    if (this.heartbeatTimer) {
      this.closeHeartbeat()
    }
    this.heartbeatTimer = setInterval(() => {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify({ type: 'heartBeat' }))
        console.log('WebSocket 发送心跳数据...')
      } else {
        console.error('WebSocket 未连接')
      }
    }, this.heartbeatInterval)
  }

  closeHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }

  disconnect() {
    this.isManualClose = true
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
      this.reconnectTimer = null
    }
    this.closeHeartbeat()
    if (this.ws) {
      this.ws.close()
      this.ws = null
    }
  }

  send(data) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(typeof data === 'string' ? data : JSON.stringify(data))
      return true
    }
    return false
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = []
    }
    this.listeners[event].push(callback)
  }

  off(event, callback) {
    if (this.listeners[event]) {
      const index = this.listeners[event].indexOf(callback)
      if (index > -1) {
        this.listeners[event].splice(index, 1)
      }
    }
  }

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => callback(data))
    }
  }

  isConnected() {
    return this.ws && this.ws.readyState === WebSocket.OPEN
  }
}

export default WebSocketManager